import { phoneInputIsValid } from 'main/util/phone'
import { TFunction } from 'react-i18next'
import { i18nKeyPrefix } from '../../../../i18n'
import { ScheduleTourModal_user } from '../../../common/gql'
import { IParams, IValidation } from './types'

export function initialParams(user: ScheduleTourModal_user) {
  return {
    noShowPolicyAgreed: false,
    password: '',
    phone: user.phone || '',
  }
}

const PRE = `${i18nKeyPrefix}-SCHEDULE-MODAL-REVIEW-CONFIRM-VALIDATIONS`

export function validate(params: IParams, skipPassword: boolean, t: TFunction) {
  const { noShowPolicyAgreed, password, phone } = params
  const validation: IValidation = {}

  if (!noShowPolicyAgreed) {
    validation.noShowPolicyAgreed = t(`${PRE}-NO-SHOW`)
  }

  if (!skipPassword) {
    if (!password) {
      validation.password = t(`${PRE}-NO-PASSWORD`)
    } else if (password.length < 2) {
      validation.password = t(`${PRE}-INVALID-PASSWORD`)
    }
  }

  if (!phone) {
    validation.phone = t(`${PRE}-NO-PHONE`)
  } else if (!phoneInputIsValid(phone)) {
    validation.phone = t(`${PRE}-INVALID-PHONE`)
  }

  return validation
}
